import type { CheckoutConfig } from '#types/config/components/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  isOpenByDefault: true
} satisfies RecursivePartial<CheckoutConfig['cartContainer']>
